import React from "react";
import DateReactive from "./DateReactive";
import DateOnApply from "./DateOnApply";
import { ElementComponentProps } from "elements/types";
import { DateElement } from "records/Element";
import { extractOnApplyParameters } from "elements/utils";

function DateContainer(props: ElementComponentProps<DateElement>) {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<DateOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<DateReactive {...props} />
	);
}

export default React.memo(DateContainer);
